/*!
 * Shockwarehouse Fitment Cross-Sell — v0.7 tracking candidate (2026-11-03)
 * Runs ON the Shopify storefront. Uses the storefront's own Convermax Garage
 * (window.Convermax, feature-detected), the public Convermax search.json, and
 * Shopify's public Ajax endpoints (products/{handle}.js, cart.js, cart/add.js).
 * No admin tokens. OFF unless window.SWX_CROSSSELL.live === true.
 * Any error/timeout/unknown -> native checkout continues.
 *
 *   window.SWX_CROSSSELL = { live: false, timeoutMs: 3000, debug: false };
 */
(function () {
  "use strict";
  var cfg = window.SWX_CROSSSELL || {};

  var SEARCH = "https://shockwarehouse.myconvermax.com/search.json";
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var TIMEOUT = cfg.timeoutMs || 3000;
  var P = {
    SHOCKS: "Shocks and Struts",
    SWAY: "Anti-Sway Bar",
    STEER: "Steering Stabilizer",
    HELPER: "Helper Springs",
    MOUNTS: "Mounts",
    STEER_MOUNT: "Steering Stabilizer Mounting Kit",
  };
  var TERM = {
    "Shocks and Struts": "Shocks-and-Struts",
    "Anti-Sway Bar": "Anti-Sway-Bar",
    "Steering Stabilizer": "Steering-Stabilizer",
    "Helper Springs": "Helper-Springs",
    Mounts: "Mounts",
  };
  var REASON = {
    "Anti-Sway Bar": "Reduces body roll and sway alongside your new shocks.",
    "Steering Stabilizer": "Helps keep steering steady and reduces wander.",
    "Helper Springs": "Supports heavy loads so your shocks can focus on damping.",
    Mounts: "Fresh mounts for a clean install.",
  };
  var TRUCKS = ["truck", "suv", "van", "commercial heavy duty truck"];

  var bypassOnce = false; // set while continuing natively -> no loop
  var shownFor = null; // once per checkout attempt (cart token + count)
  var promptedFor = null;
  var pendingCheckout = false;
  var activeTracking = null;

  // Publish custom events only. The customer-events receiver controls consent
  // and delivery; never load another Google tag or duplicate ecommerce events.
  function startTrackingAttempt() {
    var random = window.crypto && typeof window.crypto.randomUUID === "function"
      ? window.crypto.randomUUID() : Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
    return { id: "swx-" + random, sequence: 0 };
  }
  function track(name, fields, attempt) {
    attempt = attempt || activeTracking;
    if (cfg.analytics === false || !attempt) return;
    try {
      var data = {
        attempt_id: attempt.id,
        event_id: attempt.id + ":" + (++attempt.sequence),
        popup_version: "0.7",
        event_category: "swx_crosssell",
        device_category: window.innerWidth <= 767 ? "mobile" : "desktop",
      };
      // Explicit allow-list excludes cart tokens, vehicle maps, URLs and PII.
      ["step", "reason", "offer_category", "offer_brand", "product_id", "variant_id", "field", "state", "outcome", "field_count"].forEach(function (key) {
        if (fields && fields[key] != null) data[key] = typeof fields[key] === "number" ? fields[key] : String(fields[key]).slice(0,100);
      });
      ["candidate_product_ids", "candidate_variant_ids"].forEach(function (key) {
        if (fields && Array.isArray(fields[key])) data[key] = fields[key].map(String).filter(function (id) { return /^\d+$/.test(id); }).slice(0,100);
      });
      var publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish === "function") {
        var result = publish.call(window.Shopify.analytics, name, data);
        if (result && typeof result.catch === "function") result.catch(function () {});
      }
    } catch (error) { /* Analytics must never change popup/cart/checkout behavior. */ }
  }
  function offerTracking(o) {
    return {
      offer_category: o.type, offer_brand: o.item.vendor || "",
      product_id: o.item.id || "", variant_id: o.h ? String(o.h.variantId) : "",
      candidate_product_ids: (o.trackingCandidates || []).map(function (i) { return i.id; }),
      candidate_variant_ids: (o.trackingCandidates || []).reduce(function (ids,i) { return ids.concat(i.variant_ids || []); }, []),
    };
  }
  function bindOfferTracking(li, offer) {
    var attempt = activeTracking, fields = offerTracking(offer);
    [].forEach.call(li.querySelectorAll(".swx-xs-review"), function (link) {
      link.addEventListener("click", function () { track("swx_offer_review", fields, attempt); });
    });
    [].forEach.call(li.querySelectorAll("details"), function (details) {
      details.addEventListener("toggle", function () {
        track("swx_fitment_notes", Object.assign({}, fields, { state: details.open ? "expanded" : "collapsed" }), attempt);
      });
    });
  }

  function log() {
    if (cfg.debug && window.console) console.info.apply(console, ["[swx-crosssell]"].concat([].slice.call(arguments)));
  }

  function cmx() {
    var C = window.Convermax;
    if (
      !C ||
      typeof C.isVehicleSelected !== "function" ||
      typeof C.getVehicle !== "function" ||
      typeof C.getVehicleRequestParams !== "function"
    )
      return null;
    return C;
  }

  function fetchJSON(url, opts) {
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var o = Object.assign({ cache: "no-store", headers: { Accept: "application/json" } }, opts || {});
    if (ctrl) o.signal = ctrl.signal;
    return withTimeout(
      Promise.resolve()
        .then(function () {
          return fetch(url, o);
        })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        }),
    ).finally(function () {
      if (ctrl) ctrl.abort();
    });
  }

  function oos(v) {
    if (v === true || v === 1) return true;
    if (v === false || v === 0) return false;
    if (typeof v === "string") {
      var s = v.toLowerCase();
      if (s === "yes" || s === "true") return true;
      if (s === "no" || s === "false") return false;
    }
    return null; // unknown: never assume in stock
  }

  function parseItems(json) {
    return ((json && json.Items) || []).filter(function (i) {
      return typeof i.id === "string" && typeof i.handle === "string" && i.handle;
    });
  }

  function vehicleParamsWith(params, partType) {
    var base = String(params || "").replace(/^[?&]/, "");
    var n = 0,
      m,
      re = /facet\.(\d+)\.field/g;
    while ((m = re.exec(base))) n = Math.max(n, Number(m[1]) + 1);
    var add =
      "facet." +
      n +
      ".field=" +
      encodeURIComponent("Part Type") +
      "&facet." +
      n +
      ".selection=" +
      encodeURIComponent(TERM[partType]) +
      "&pageSize=300";
    return base ? base + "&" + add : add;
  }

  function targetsFor(vehicleType) {
    var vt = String(vehicleType || "")
      .trim()
      .toLowerCase();
    if (vt === "motorhome") return [P.SWAY, P.STEER, P.HELPER];
    if (TRUCKS.indexOf(vt) >= 0) return [P.HELPER, P.SWAY, P.STEER, P.MOUNTS];
    return []; // cars: wait for verified bare-vs-complete strut data
  }

  function vehicleType(v) {
    if (!v) return "";
    var x = v.VehicleType;
    return typeof x === "object" && x ? x.Value || x.value || "" : x || "";
  }

  // ---- Verified-integration helpers (pure; exported for tests) ----
  function fitResult(r) {
    if (r && typeof r === "object") {
      if (
        [r.universal, r.isUniversal, r.aggressive, r.isAggressive].some(function (v) {
          return v === true || v === "yes" || v === "true";
        })
      )
        return "unknown";
      var v =
        r.fitsTheVehicle != null ? r.fitsTheVehicle : r.fits != null ? r.fits : r.Fits != null ? r.Fits : r.result;
      return fitResult(v);
    }
    if (r === true || (typeof r === "string" && r.toLowerCase() === "yes")) return "yes";
    if (r === false || (typeof r === "string" && r.toLowerCase() === "no")) return "no";
    return "unknown"; // ambiguous => never assume fit
  }
  function normalizeProduct(r) {
    if (!r) return null;
    var x = r.Item || r.item || (r.Items && r.Items[0]) || r;
    if (!x || typeof x !== "object") return null;
    var b = x.is_bundle_product;
    var raw = typeof x.Part_Type === "string" ? x.Part_Type : null;
    var family = String(x.Brand || "").trim();
    // Catalog families and the ACES name are structured source data. Never
    // infer a category, kit contents or compatibility from a product title.
    var aliases = { "Suspension Stabilizer Bar Kit": P.SWAY, "Sway Bar": P.SWAY };
    var type = aliases[raw] || raw;
    var fallback = !type && (family === "Sway Bar" || family === P.SWAY);
    if (fallback) type = P.SWAY;
    if (family === P.STEER_MOUNT && (!type || type === P.STEER)) type = P.STEER_MOUNT;
    var vendor = String(x.vendor || "").trim();
    var bundled = b === true || (typeof b === "string" && /^(true|yes)$/i.test(b));
    return {
      partType: type,
      isBundle: bundled,
      vendor: vendor,
      family: family,
      categoryReview: !!fallback,
      requiresMount: type === P.STEER && vendor === "Safe-T-Plus" && family === P.STEER && !bundled,
      mountIncluded:
        type === P.STEER &&
        bundled &&
        /^(Exact Center Steering Stabilizer Full Kit|Steering Stabilizer Full Kit)$/.test(family),
    };
  }
  /** Decide which categories to offer. Any doubt => skip. */
  function planTargets(vt, products) {
    if (!products.length) return { targets: [], reason: "empty" };
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p.info || !p.info.partType) return { targets: [], reason: "unresolved-product" };
      if (p.info.isBundle) return { targets: [], reason: "bundle-in-cart" };
    }
    // Every resolved cart line belongs to the selected vehicle. A non-shock
    // from another Garage vehicle must not qualify this checkout either.
    for (var k = 0; k < products.length; k++) {
      if (products[k].fit === "no") return { targets: [], reason: "vehicle-mismatch" };
      if (products[k].fit !== "yes") return { targets: [], reason: "vehicle-unverified" };
    }
    var shocks = products.filter(function (p) {
      return p.info.partType === P.SHOCKS || p.info.requiresMount;
    });
    if (!shocks.length) return { targets: [], reason: "no-shocks" };
    for (var j = 0; j < shocks.length; j++) {
      if (shocks[j].fit === "no") return { targets: [], reason: "vehicle-mismatch" };
      if (shocks[j].fit !== "yes") return { targets: [], reason: "vehicle-unverified" };
    }
    var inCart = products.map(function (p) {
      return p.info.partType;
    });
    var missingMount = products.some(function (p) {
      return p.info.requiresMount;
    });
    var hasShocks = products.some(function (p) {
      return p.info.partType === P.SHOCKS;
    });
    var t = (hasShocks ? targetsFor(vt) : []).filter(function (x) {
      return inCart.indexOf(x) < 0;
    });
    if (missingMount) t.unshift(P.STEER_MOUNT);
    return { targets: t, reason: t.length ? "ok" : "no-targets" };
  }
  function isCheckoutSubmit(form, sub) {
    if (!form || !sub || sub.name !== "checkout" || isAccelerated(sub)) return false;
    try {
      return /\/cart\/?$/.test(new URL(form.getAttribute("action") || form.action, location.href).pathname);
    } catch (e) {
      return false;
    }
  }
  function checkoutLinkFrom(target) {
    var a = target && target.closest && target.closest("a[href]");
    if (!a || isAccelerated(a)) return null;
    try {
      var u = new URL(a.getAttribute("href"), location.href);
      return u.origin === location.origin && /\/checkout\/?$/.test(u.pathname) ? a : null;
    } catch (e) {
      return null;
    }
  }

  // Internal add eligibility only, never a customer stock label. No authoritative
  // explicit backorder field is verified; available/out_of_stock/policies cannot prove backorder.
  // Confirm the variant is available and get the current price (cents) from Shopify itself.
  function hydrate(item) {
    return fetchJSON(ROOT + "products/" + encodeURIComponent(item.handle) + ".js").then(function (p) {
      var ids = (item.variant_ids || []).map(String);
      var v = (p.variants || []).filter(function (x) {
        return ids.indexOf(String(x.id)) >= 0 && x.available === true;
      })[0];
      return v ? { variantId: v.id, priceCents: v.price, url: p.url || item.url } : null;
    });
  }

  // Snapshot once; never combine cart evidence for one vehicle with offers for another.
  function stableJSON(value) {
    if (!value || typeof value !== "object") return JSON.stringify(value);
    if (Array.isArray(value)) return "[" + value.map(stableJSON).join(",") + "]";
    return (
      "{" +
      Object.keys(value)
        .sort()
        .map(function (key) {
          return JSON.stringify(key) + ":" + stableJSON(value[key]);
        })
        .join(",") +
      "}"
    );
  }
  function freezeVehicle(value) {
    if (value && typeof value === "object") {
      Object.keys(value).forEach(function (key) {
        freezeVehicle(value[key]);
      });
      Object.freeze(value);
    }
    return value;
  }
  function captureSelection(C) {
    if (!C.isVehicleSelected()) throw new Error("vehicle-unverified");
    var vehicle = freezeVehicle(JSON.parse(JSON.stringify(C.getVehicle())));
    var params = String(C.getVehicleRequestParams() || "").replace(/^[?&]/, "");
    var query = new URLSearchParams(params);
    // Independent catalog proof requires actual vehicle facets, not an unfiltered SKU search.
    var fields = [];
    query.forEach(function (value, key) {
      var m = /^facet\.(\d+)\.field$/.exec(key);
      if (m && query.get("facet." + m[1] + ".selection")) fields.push(value);
    });
    if (
      !["VehicleType", "Year", "Make", "Model"].every(function (field) {
        return fields.indexOf(field) >= 0;
      })
    )
      throw new Error("vehicle-unverified");
    var fingerprint = stableJSON(vehicle),
      changed = false;
    var snapshot = {
      vehicle: vehicle,
      params: params,
      assertCurrent: function () {
        if (
          !C.isVehicleSelected() ||
          fingerprint !== stableJSON(C.getVehicle()) ||
          params !== String(C.getVehicleRequestParams() || "").replace(/^[?&]/, "")
        )
          changed = true;
        if (changed) throw new Error("vehicle-changed");
      },
    };
    snapshot.assertCurrent();
    return snapshot;
  }
  function catalogCartFit(C, lines, id, snapshot) {
    snapshot.assertCurrent();
    if (
      !lines.length ||
      lines.some(function (line) {
        return (
          typeof line.sku !== "string" || !line.sku.trim() || line.variant_id == null || !String(line.variant_id).trim()
        );
      })
    )
      return Promise.resolve("unknown");
    var variants = lines.map(function (line) {
      return String(line.variant_id);
    });
    // An exact-SKU keyword query can redirect to a product and omit fitment.
    // Keep the vehicle facets, omit keyword search, and prove identity separately.
    if (!snapshot.cartCatalog) snapshot.cartCatalog = fetchJSON(SEARCH + "?" + snapshot.params + "&pageSize=300");
    return snapshot.cartCatalog.then(function (json) {
      snapshot.assertCurrent();
      if (
        json.Query ||
        (json.Actions || []).some(function (a) {
          return a.Type === "Redirect";
        })
      )
        return "unknown";
      var item = parseItems(json).filter(function (i) {
        var info = normalizeProduct(i);
        return (
          i.id === id &&
          info &&
          info.partType &&
          Array.isArray(i.variant_ids) &&
          variants.every(function (v) {
            return i.variant_ids.map(String).indexOf(v) >= 0;
          }) &&
          lines.every(function (line) {
            return String(i.sku_stored || i.sku || "").trim() === line.sku.trim();
          })
        );
      })[0];
      if (!item) return "unknown";
      if (item.fitsTheVehicle === "specify") snapshot.needsDetails = true;
      return fitResult(item.fitsTheVehicle);
    });
  }

  function recoverCartInfo(cart, id, snapshot) {
    if (!snapshot.cartCatalog) snapshot.cartCatalog = fetchJSON(SEARCH + "?" + snapshot.params + "&pageSize=300");
    return snapshot.cartCatalog.then(function (json) {
      snapshot.assertCurrent();
      if (
        json.Query ||
        (json.Actions || []).some(function (a) {
          return a.Type === "Redirect";
        })
      )
        return null;
      var lines = cart.items.filter(function (line) {
        return String(line.product_id) === id;
      });
      var item = parseItems(json).filter(function (i) {
        return (
          i.id === id &&
          lines.length &&
          lines.every(function (line) {
            return (
              line.variant_id != null &&
              typeof line.sku === "string" &&
              line.sku.trim() &&
              (i.variant_ids || []).map(String).indexOf(String(line.variant_id)) >= 0 &&
              String(i.sku_stored || i.sku || "").trim() === line.sku.trim()
            );
          })
        );
      })[0];
      return item ? normalizeProduct(item) : null;
    });
  }

  function vehicleSearchURL(params, type, vendor, bundle) {
    var query = new URLSearchParams(params),
      parts = [];
    query.forEach(function (value, key) {
      var m = /^facet\.(\d+)\.field$/.exec(key);
      if (m) {
        var selection = query.get("facet." + m[1] + ".selection");
        if (selection) parts.push(encodeURIComponent(value), encodeURIComponent(selection));
      }
    });
    if (type) parts.push("Part-Type", encodeURIComponent(TERM[type]));
    if (vendor) parts.push("vendor", encodeURIComponent(vendor.replace(/ /g, "-")));
    if (bundle) parts.push("is_bundle_product", "True");
    return ROOT + "search?" + parts.join("/");
  }

  function preference(item, type) {
    var name = [item.vendor, item.Brand, item.title].join(" ");
    if (type === P.HELPER) return /sumo\s*springs/i.test(name) ? 0 : /timbren/i.test(name) ? 1 : 2;
    if (type === P.STEER) {
      if (/safe[\s-]*t[\s-]*plus/i.test(name)) return 0;
      if (/roadmaster/i.test(name) && /exact\s*center|reflex/i.test(name)) return 1;
      return /bilstein/i.test(name) ? 2 : 3;
    }
    return 0;
  }

  function isF53(snapshot) {
    return (
      vehicleType(snapshot.vehicle).toLowerCase() === "motorhome" &&
      /f[\s-]*53/i.test(stableJSON(snapshot.vehicle.Model))
    );
  }
  function resolveCart(C, cart, snapshot) {
    snapshot = snapshot || captureSelection(C);
    var ids = [];
    cart.items.forEach(function (i) {
      var id = String(i.product_id);
      if (ids.indexOf(id) < 0) ids.push(id);
    });
    return Promise.all(
      ids.map(function (id) {
        var info =
          typeof C.getProductAsync === "function"
            ? withTimeout(
                Promise.resolve().then(function () {
                  snapshot.assertCurrent();
                  return C.getProductAsync(id);
                }),
              ).then(normalizeProduct, function () {
                return null;
              })
            : Promise.resolve(null);
        return info
          .then(function (inf) {
            // getProductAsync can omit Brand; enrich metadata from the snapshot's vehicle catalog (fit still verified below).
            if (!inf || !inf.partType || (inf.partType === P.STEER && !inf.family && !inf.isBundle)) {
              return recoverCartInfo(cart, id, snapshot).then(function (current) {
                return current || inf;
              });
            }
            return inf;
          })
          .then(function (inf) {
            snapshot.assertCurrent();
            if (!inf || !inf.partType) return { id: id, info: inf, fit: "unknown" };
            if (typeof C.verifyFitmentAsync !== "function") return { id: id, info: inf, fit: "unknown" };
            return withTimeout(
              Promise.resolve().then(function () {
                snapshot.assertCurrent();
                return C.verifyFitmentAsync(id, snapshot.vehicle);
              }),
            ).then(
              function (r) {
                snapshot.assertCurrent();
                if (r === "specify" || (r && r.fitsTheVehicle === "specify")) snapshot.needsDetails = true;
                return { id: id, info: inf, fit: fitResult(r) };
              },
              function () {
                // Only rejected/thrown calls reach this branch; explicit no/unknown is never overridden.
                return catalogCartFit(
                  C,
                  cart.items.filter(function (line) {
                    return String(line.product_id) === id;
                  }),
                  id,
                  snapshot,
                ).then(function (fit) {
                  return { id: id, info: inf, fit: fit };
                });
              },
            );
          });
      }),
    );
  }

  function withTimeout(p) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error("timeout"));
      }, TIMEOUT);
      p.then(
        function (value) {
          clearTimeout(timer);
          resolve(value);
        },
        function (error) {
          clearTimeout(timer);
          reject(error);
        },
      );
    });
  }

  function buildOffers(C, cart) {
    var snapshot = captureSelection(C);
    var vt = vehicleType(snapshot.vehicle);
    var cartIds = cart.items.map(function (i) {
      return String(i.product_id);
    });
    var cartVariants = cart.items.map(function (i) {
      return String(i.variant_id);
    });
    return resolveCart(C, cart, snapshot).then(function (products) {
      snapshot.assertCurrent();
      var plan = planTargets(vt, products);
      log("plan", plan.reason, plan.targets);
      if (!plan.targets.length) {
        if (plan.reason === "vehicle-unverified" && snapshot.needsDetails) {
          var e = new Error("vehicle-details-required");
          e.searchURL = vehicleSearchURL(snapshot.params);
          e.snapshot = snapshot;
          e.cart = cart;
          throw e;
        }
        return [];
      }
      // Read the current vehicle catalog as well as the indexed categories.
      // This retains structured families during a part-type mapping re-index.
      var catalog = snapshot.cartCatalog || fetchJSON(SEARCH + "?" + snapshot.params + "&pageSize=300");
      snapshot.cartCatalog = catalog;
      return Promise.all(
        [catalog].concat(
          plan.targets.map(function (t) {
            if (t === P.STEER_MOUNT) return Promise.resolve([]);
            return fetchJSON(SEARCH + "?" + vehicleParamsWith(snapshot.params, t)).then(function (json) {
              snapshot.assertCurrent();
              return parseItems(json);
            });
          }),
        ),
      ).then(function (lists) {
        var current = parseItems(lists.shift());
        var jobs = [];
        plan.targets.forEach(function (type, idx) {
          var pool = lists[idx].concat(current).filter(function (item, index, all) {
            return (
              all.findIndex(function (other) {
                return other.id === item.id;
              }) === index && normalizeProduct(item).partType === type
            );
          });
          if (type === P.STEER_MOUNT) {
            var verifiedOptions = pool.some(function (i) {
              return i.fitsTheVehicle === "yes" && i.vendor === "Safe-T-Plus";
            });
            var kitInCart = products.some(function (p) {
              return p.info && p.info.partType === P.STEER_MOUNT && p.info.vendor === "Safe-T-Plus";
            });
            // Vehicle fit alone does not establish tie-rod/U-bolt dimensions.
            // Never choose or add an arbitrary mounting kit from these options.
            jobs.push(
              Promise.resolve({
                type: type,
                item: { vendor: "Safe-T-Plus", title: "Safe-T-Plus mounting kit required" },
                dependency: true,
                trackingCandidates: current.filter(function (i) { return i.vendor === "Safe-T-Plus" && (normalizeProduct(i).partType === P.STEER || normalizeProduct(i).partType === P.STEER_MOUNT); }),
                review: true,
                snapshot: snapshot,
                mountNotice:
                  (kitInCart
                    ? "A separate mounting kit is in your cart. Confirm it matches this stabilizer and your measured tie-rod and suspension U-bolt dimensions before ordering. "
                    : "Mounting kit sold separately. Measure your tie rod and suspension U-bolt before choosing a kit. ") +
                  (verifiedOptions
                    ? "Vehicle-matched options still require these measurements; no kit has been selected for you."
                    : "A compatible kit has not been verified. Contact Shockwarehouse with your measurements."),
                reviewURL: vehicleSearchURL(snapshot.params, P.STEER, "Safe-T-Plus"),
              }),
            );
            return;
          }
          var covered = pool.some(function (i) {
            return (
              cartIds.indexOf(i.id) >= 0 ||
              (i.variant_ids || []).some(function (v) {
                return cartVariants.indexOf(String(v)) >= 0;
              })
            );
          });
          if (covered) return;
          var cands = pool
            .filter(function (i) {
              return (
                normalizeProduct(i).partType === type &&
                i.fitsTheVehicle === "yes" &&
                oos(i.out_of_stock) !== true &&
                (i.variant_ids || []).length
              );
            })
            .map(function (item, order) {
              return { item: item, order: order };
            })
            .sort(function (a, b) {
              return preference(a.item, type) - preference(b.item, type) || a.order - b.order;
            })
            .map(function (x) {
              return x.item;
            })
            .slice(0, 12);
          jobs.push(
            Promise.all(
              cands.map(function (c) {
                return hydrate(c).then(
                  function (h) {
                    snapshot.assertCurrent();
                    if (!h) return null;
                    var vendorOptions = pool.filter(function (option) {
                      return option.vendor === c.vendor && option.fitsTheVehicle !== "no" &&
                        oos(option.out_of_stock) !== true && (option.variant_ids || []).length;
                    });
                    var hasChoices = vendorOptions.length > 1 || (c.variant_ids || []).length > 1;
                    var browse = isF53(snapshot);
                    var info = normalizeProduct(c);
                    var mountNotice = info.requiresMount
                      ? "Mounting kit required and sold separately. Measure your tie rod and suspension U-bolt to choose the correct kit; this stabilizer does not include it."
                      : info.mountIncluded
                        ? "Mounting hardware is included in this kit. Confirm the fitment details before ordering."
                        : null;
                    return {
                      item: c,
                      trackingCandidates: current.concat(pool).filter(function (i,index,all) {
                        var part = normalizeProduct(i).partType;
                        return i.vendor === c.vendor && (part === type || (type === P.STEER && part === P.STEER_MOUNT)) &&
                          i.fitsTheVehicle !== "no" && all.findIndex(function (other) { return other.id === i.id; }) === index;
                      }),
                      type: type,
                      h: h,
                      snapshot: snapshot,
                      browse: browse,
                      mountNotice: browse ? null : mountNotice,
                      review: browse || hasChoices || info.categoryReview || info.requiresMount || !!String(c.Notes || "").trim(),
                      reviewURL: vehicleSearchURL(snapshot.params, type, c.vendor),
                      browseURL: browse
                        ? vehicleSearchURL(
                            snapshot.params,
                            type,
                            c.vendor,
                            false,
                          )
                        : null,
                    };
                  },
                  function () {
                    return null;
                  },
                );
              }),
            ).then(function (rows) {
              return rows.filter(Boolean)[0] || null;
            }),
          );
        });
        return Promise.all(jobs).then(function (r) {
          snapshot.assertCurrent();
          return r.filter(Boolean).slice(0, 4);
        });
      });
    });
  }

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text; // never innerHTML with catalog data
    return n;
  }
  function notesText(html) {
    var d = new DOMParser().parseFromString(
      "<div>" + String(html).replace(/<br\s*\/?>/gi, "\n") + "</div>",
      "text/html",
    );
    return (d.body.textContent || "").trim();
  }
  function money(c) {
    return "$" + (Number(c) / 100).toFixed(2);
  }

  function refreshCartAfterAdd() {
    if (/\/cart\/?$/.test(location.pathname)) {
      window.location.reload();
      return;
    }
    try {
      if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
        window.ajaxCart.load();
        return;
      }
    } catch (e) {
      /* The add succeeded; refresh failure must not invite a duplicate add. */
    }
    window.location.assign(ROOT + "cart");
  }

  function continueNative(form, submitter, href) {
    bypassOnce = true;
    if (href) window.location.assign(href);
    else if (form) {
      if (submitter && submitter.name)
        form.appendChild(el("input", { type: "hidden", name: submitter.name, value: submitter.value || "" }));
      HTMLFormElement.prototype.submit.call(form);
    } else window.location.assign(ROOT + "checkout");
  }

  function modal(title, subtitle, build, onDone, step) {
    step = step || "offers";
    var attempt = activeTracking, closed = false;
    var last = document.activeElement;
    var overlay = el("div", { class: "swx-xs-overlay" });
    var dlg = el("div", {
      class: "swx-xs-dialog",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "swx-xs-title",
    });
    var head = el("div", { class: "swx-xs-head" });
    head.appendChild(
      el("img", {
        class: "swx-xs-logo",
        src: "https://www.shockwarehouse.com/cdn/shop/files/ShockWarehouse-Logo.png?v=1663878107",
        alt: "Shockwarehouse",
        width: "230",
        height: "71",
      }),
    );
    head.appendChild(el("h2", { id: "swx-xs-title" }, title));
    if (subtitle) head.appendChild(subtitle);
    var close = el("button", { type: "button", class: "swx-xs-close", "aria-label": "Close" }, "\u00d7");
    head.appendChild(close);
    dlg.appendChild(head);
    function teardown() {
      if (closed) return;
      closed = true;
      document.removeEventListener("keydown", onKey);
      overlay.remove();
      shownFor = null;
      promptedFor = null;
      if (last && last.focus) last.focus();
    }
    function dismiss(reason) {
      if (closed) return;
      track("swx_popup_dismiss", { step: step, reason: reason }, attempt);
      teardown();
    }
    function onKey(e) {
      if (e.key === "Escape") dismiss("escape");
      else if (e.key === "Tab") {
        var f = [].filter.call(dlg.querySelectorAll("button:not([disabled]), select:not([disabled]), input:not([disabled]), a[href], summary"), function (n) {
          return n.getClientRects().length > 0;
        });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) {
          e.preventDefault();
          f[f.length - 1].focus();
        } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
          e.preventDefault();
          f[0].focus();
        }
      }
    }
    var foot = el("div", { class: "swx-xs-foot" });
    var skip = el("button", { type: "button", class: "swx-xs-skip" }, "No thanks, skip to checkout");
    var go = el("button", { type: "button", class: "swx-xs-go" }, "Continue to checkout");
    var body = el("div", { class: "swx-xs-body" });
    build(body, teardown);
    dlg.appendChild(body);
    foot.appendChild(skip);
    foot.appendChild(go);
    dlg.appendChild(foot);
    overlay.appendChild(dlg);
    document.body.appendChild(overlay);
    track("swx_popup_shown", { step: step }, attempt);
    go.focus();
    document.addEventListener("keydown", onKey);
    close.addEventListener("click", function () { dismiss("close_button"); });
    overlay.addEventListener("mousedown", function (e) {
      if (e.target === overlay) dismiss("backdrop");
    });
    skip.addEventListener("click", function () {
      if (closed) return;
      track("swx_popup_skip", { step: step }, attempt);
      teardown();
      onDone();
    });
    go.addEventListener("click", function () {
      if (closed) return;
      track("swx_popup_continue", { step: step }, attempt);
      teardown();
      onDone();
    });
  }

  function changeVehicleLink(C, teardownRef) {
    if (typeof C.openVehicleDialog !== "function") return null;
    var b = el("button", { type: "button", class: "swx-xs-link" }, "Change vehicle");
    b.addEventListener("click", function () {
      track("swx_vehicle_change", {});
      teardownRef.fn();
      C.openVehicleDialog();
    });
    return b;
  }

  function renderOffers(C, offers, done) {
    var sub = el("p", null);
    var label = typeof C.getVehicleString === "function" ? C.getVehicleString() : "";
    sub.appendChild(document.createTextNode("Listed for your " + (label || "vehicle") + " "));
    var ref = { fn: function () {} };
    var cv = changeVehicleLink(C, ref);
    if (cv) sub.appendChild(cv);
    modal(
      "Complete your suspension setup",
      sub,
      function (dlg, teardown) {
        ref.fn = teardown;
        var list = el("ul", { class: "swx-xs-list" });
        offers.forEach(function (o) {
          var li = el("li", { class: "swx-xs-card", "data-type": o.type });
          if (o.dependency) {
            li.appendChild(el("h3", null, o.item.title));
            li.appendChild(el("p", null, o.mountNotice));
            li.appendChild(
              el(
                "a",
                { href: o.reviewURL, target: "_blank", rel: "noopener", class: "swx-xs-review" },
                "Review mounting kit options",
              ),
            );
            bindOfferTracking(li, o);
            list.appendChild(li);
            return;
          }
          if (!o.browse && o.item.image) li.appendChild(el("img", { src: o.item.image, alt: "", loading: "lazy" }));
          li.appendChild(el("h3", null, o.browse ? (o.item.vendor || "") + " " + o.type + " options" : o.item.title));
          li.appendChild(el("p", null, REASON[o.type] || ""));
          if (o.mountNotice) li.appendChild(el("p", { class: "swx-xs-mount-notice" }, o.mountNotice));
          if (o.review) {
            var n = el("div", { class: "swx-xs-notes swx-xs-notes-desktop" });
            n.appendChild(el("strong", null, "Check before buying — fit depends on these details:"));
            var fitmentNotes = o.browse
              ? "F53 fitment depends on engine, GVWR and chassis configuration. Review the available options and confirm these details before choosing a part."
              : notesText(
                  o.item.Notes ||
                    "Confirm the application and installation requirements on the product page before ordering.",
                );
            n.appendChild(el("p", null, fitmentNotes));
            li.appendChild(n);
            var disclosure = el("details", { class: "swx-xs-notes swx-xs-notes-mobile" });
            disclosure.appendChild(el("summary", null, "Fitment notes"));
            var content = el("div", { class: "swx-xs-notes-content" });
            content.appendChild(el("strong", null, "Check before buying — fit depends on these details:"));
            content.appendChild(el("p", null, fitmentNotes));
            disclosure.appendChild(content);
            li.appendChild(disclosure);
          }
          if (!o.browse) li.appendChild(el("strong", { class: "swx-xs-price" }, money(o.h.priceCents)));
          if (o.review) {
            li.appendChild(
              el(
                "a",
                {
                  href: o.browse ? o.browseURL : o.reviewURL || o.h.url,
                  target: "_blank",
                  rel: "noopener",
                  class: "swx-xs-review",
                  "aria-label":
                    "Review fitment options: " +
                    (o.browse ? o.type : o.item.title) +
                    " (opens new tab)",
                },
                "Review fitment options",
              ),
            );
          } else {
            var add = el("button", { type: "button" }, "Add to cart");
            var addAttempt = activeTracking;
            add.addEventListener("click", function () {
              try {
                o.snapshot.assertCurrent();
              } catch (e) {
                track("swx_offer_add_blocked", Object.assign({}, offerTracking(o), { reason: "vehicle_changed" }), addAttempt);
                add.disabled = true;
                add.textContent = "Vehicle changed — reopen checkout";
                return;
              }
              add.disabled = true;
              var addSucceeded = false;
              track("swx_offer_add_click", offerTracking(o), addAttempt);
              fetchJSON(ROOT + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: [{ id: o.h.variantId, quantity: 1 }] }),
              })
                .then(function () {
                  addSucceeded = true;
                  track("swx_offer_add_success", offerTracking(o), addAttempt);
                  shownFor = null; // cart changed; still treat this as the same attempt via bypass on continue
                  refreshCartAfterAdd();
                  li.remove();
                  if (o.type === P.HELPER)
                    [].forEach.call(list.querySelectorAll('[data-type="Helper Springs"]'), function (x) {
                      x.remove();
                    });
                })
                .catch(function () {
                  if (!addSucceeded) track("swx_offer_add_error", Object.assign({}, offerTracking(o), { reason: "request_failed" }), addAttempt);
                  add.disabled = false;
                  add.textContent = "Couldn't add — try again";
                });
            });
            li.appendChild(add);
          }
          bindOfferTracking(li, o);
          list.appendChild(li);
        });
        dlg.appendChild(list);
        dlg.appendChild(
          el(
            "p",
            { class: "swx-xs-fine" },
            "Listed by our vehicle catalog. Please confirm fit details before ordering.",
          ),
        );
      },
      done,
    );
  }

  function renderVehiclePrompt(C, done) {
    modal(
      "Complete your suspension setup",
      el("p", null, "Select your vehicle to see parts listed for it."),
      function (dlg, teardown) {
        var b = el("button", { type: "button", class: "swx-xs-go" }, "Select vehicle");
        b.addEventListener("click", function () {
          track("swx_vehicle_select", { step: "vehicle" });
          teardown();
          C.openVehicleDialog();
        });
        var w = el("div", { class: "swx-xs-list" });
        w.appendChild(b);
        dlg.appendChild(w);
      },
      done, "vehicle",
    );
  }

  // Facet options come only from the selected vehicle's Convermax catalog.
  // Updating Garage never substitutes for verifying cart or recommended fit.
  function refinementFields(json) {
    return ["Drive", "Submodel", "Engine", "Body"].map(function (key) {
      return (json.Facets || []).filter(function (f) { return f.FieldName === key; })[0];
    }).filter(function (f) { return f && Array.isArray(f.Values) && f.Values.length; });
  }
  function vehicleFacetParams(vehicle) {
    var q = new URLSearchParams();
    Object.keys(vehicle).forEach(function (key, index) {
      var value = vehicle[key];
      if (value && typeof value === "object") value = value.Value || value.value;
      if (value != null && String(value)) {
        q.set("facet." + index + ".field", key);
        q.set("facet." + index + ".selection", String(value).replace(/ /g, "-"));
      }
    });
    return q.toString();
  }
  function cartDetailState(json, cart, vehicle) {
    var needed = [], items = parseItems(json), exact = true, fits = true;
    (cart.items || []).forEach(function (line) {
      var item = items.filter(function (i) {
        return i.id === String(line.product_id) &&
          (i.variant_ids || []).map(String).indexOf(String(line.variant_id)) >= 0 &&
          typeof line.sku === "string" && line.sku.trim() &&
          String(i.sku_stored || i.sku || "").trim() === line.sku.trim();
      })[0];
      if (!item) { exact = false;fits = false;return; }
      if (fitResult(item.fitsTheVehicle) !== "yes") fits = false;
      ["Drive", "Submodel", "Engine", "Body"].forEach(function (key) {
        if (typeof item[key] === "string" && item[key].trim() && !vehicle[key] && needed.indexOf(key) < 0) needed.push(key);
      });
    });
    return { fits: exact && fits && !!(cart.items || []).length, needed: needed, exact: exact };
  }
  function renderVehicleDetails(C, error, done, retry) {
    modal("Confirm your vehicle details",
      el("p", null, "Choose your trim, engine or cab details here so we can recheck the parts in your cart."),
      function (body, teardown) {
        var detailAttempt = activeTracking;
        var wrap = el("div", { class: "swx-xs-refine" });
        var fields = el("div", { class: "swx-xs-refine-fields" });
        var status = el("p", { role: "status", "aria-live": "polite" }, "Loading vehicle details…");
        var apply = el("button", { type: "button", class: "swx-xs-go" }, "Check fitment");
        apply.disabled = true;
        var fallback = el("a", { href: error.searchURL, class: "swx-xs-review" }, "Refine on the vehicle results page");
        wrap.appendChild(fields);wrap.appendChild(status);wrap.appendChild(apply);wrap.appendChild(fallback);body.appendChild(wrap);
        if (!error.snapshot || typeof C.setVehicle !== "function") {
          status.textContent = "Use the vehicle results page to complete these details.";
          apply.hidden = true;return;
        }
        var snapshot = error.snapshot, chosen = JSON.parse(JSON.stringify(snapshot.vehicle)), sequence = 0;
        var order = ["Drive", "Submodel", "Engine", "Body"];
        var labels = { Drive: "Drive", Submodel: "Trim / submodel", Engine: "Engine", Body: "Cab / body type" };
        function valueOf(v) { return v && typeof v === "object" ? v.Value || v.value || "" : String(v || ""); }
        function refresh() {
          var request = ++sequence;
          apply.disabled = true;status.textContent = "Loading vehicle details…";
          fetchJSON(SEARCH + "?" + vehicleFacetParams(chosen) + "&pageSize=300").then(function (json) {
            if (!wrap.isConnected || request !== sequence) return;
            snapshot.assertCurrent();
            fields.replaceChildren();
            var facets = refinementFields(json);
            var detail = error.cart ? cartDetailState(json, error.cart, chosen) : null;
            facets.forEach(function (facet) {
              var key = facet.FieldName;
              var optional = detail && detail.exact && detail.needed.indexOf(key) < 0 && !chosen[key];
              var label = el("label", null, labels[key] + (optional ? " (optional for these cart items)" : ""));
              var select = el("select", { "aria-label": labels[key] });
              select.appendChild(el("option", { value: "" }, "Choose " + labels[key].toLowerCase()));
              facet.Values.forEach(function (v) {
                if (typeof v.Value !== "string" || !v.Value) return;
                select.appendChild(el("option", { value: v.Value }, v.Value));
              });
              select.value = valueOf(chosen[key]);
              if (!select.value) delete chosen[key];
              select.addEventListener("change", function () {
                track("swx_fitment_field", { field: key, state: select.value ? "selected" : "cleared" }, detailAttempt);
                if (select.value) chosen[key] = select.value;else delete chosen[key];
                order.slice(order.indexOf(key) + 1).forEach(function (later) { delete chosen[later]; });
                refresh();
              });
              label.appendChild(select);fields.appendChild(label);
            });
            // Do not force every facet merely because the catalog exposes it.
            // Recheck the actual cart after any explicit choice; never guess a value.
            var ready = facets.length && order.some(function (key) {
              return valueOf(chosen[key]) && valueOf(chosen[key]) !== valueOf(snapshot.vehicle[key]);
            });
            apply.disabled = !ready;
            status.textContent = detail && detail.fits
              ? "The catalog matches these cart items. Remaining details are optional for this cart; check fitment to confirm."
              : "Choose the details needed for your cart, then check fitment. Other refinements can be left blank; we won’t assume a match.";
          }).catch(function () {
            if (!wrap.isConnected || request !== sequence) return;
            status.textContent = "These details could not be loaded. You can refine on the vehicle results page or continue to checkout.";
          });
        }
        apply.addEventListener("click", function () {
          track("swx_fitment_submit", { field_count: order.filter(function (key) { return !!valueOf(chosen[key]); }).length }, detailAttempt);
          apply.disabled = true;
          try { snapshot.assertCurrent(); } catch (e) { status.textContent = "Your selected vehicle changed. Close and reopen checkout.";return; }
          status.textContent = "Updating your vehicle and rechecking fitment…";
          Promise.resolve().then(function () { return C.setVehicle(chosen); }).then(function () {
            var current = C.getVehicle();
            if (!C.isVehicleSelected() || !Object.keys(chosen).every(function (k) { return valueOf(current[k]) === valueOf(chosen[k]); })) throw new Error("vehicle-not-updated");
            track("swx_vehicle_updated", {}, detailAttempt);
            teardown();shownFor = null;promptedFor = null;retry();
          }).catch(function () { track("swx_fitment_error", { reason: "vehicle_update_unconfirmed" }, detailAttempt);status.textContent = "Your vehicle update could not be confirmed. Please use the vehicle results page.";apply.disabled = false; });
        });
        refresh();
      }, done, "details");
  }

  function isAccelerated(n) {
    return !!(
      n &&
      n.closest &&
      n.closest(
        ".shopify-payment-button, [data-shopify='payment-button'], .additional-checkout-buttons, dynamic-checkout, shopify-accelerated-checkout, shopify-accelerated-checkout-cart",
      )
    );
  }

  function intercept(form, sub, C, href, resumedAttempt) {
    if (pendingCheckout || document.querySelector(".swx-xs-overlay")) return;
    pendingCheckout = true;
    activeTracking = resumedAttempt || startTrackingAttempt();
    var attempt = activeTracking;
    if (!resumedAttempt) track("swx_checkout_attempt", {}, attempt);
    var cont = function () {
      continueNative(form, sub, href);
    };
    fetchJSON(ROOT + "cart.js")
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { track("swx_popup_bypass", { reason: "empty_cart" }, attempt);return cont(); }
        var token = cart.token + ":" + cart.item_count;
        if (shownFor === token) return cont();
        if (!C.isVehicleSelected()) {
          if (promptedFor === token || typeof C.openVehicleDialog !== "function") return cont();
          promptedFor = token;
          return renderVehiclePrompt(C, cont);
        }
        return buildOffers(C, cart).then(function (offers) {
          if (!offers.length) { track("swx_popup_bypass", { reason: "no_qualified_offers" }, attempt);return cont(); }
          if (resumedAttempt) track("swx_fitment_resolved", {}, attempt);
          shownFor = token;
          renderOffers(C, offers, cont);
        });
      })
      .catch(function (e) {
        if (e && e.message === "vehicle-details-required") {
          return renderVehicleDetails(C, e, cont, function () { intercept(form, sub, C, href, attempt); });
        }
        log("bypass:", e && e.message);
        track("swx_popup_bypass", { reason: "qualification_error" }, attempt);
        cont();
      })
      .finally(function () {
        pendingCheckout = false;
      });
  }

  window.SWXCrossSellCore = {
    fitResult: fitResult,
    normalizeProduct: normalizeProduct,
    planTargets: planTargets,
    targetsFor: targetsFor,
    vehicleParamsWith: vehicleParamsWith,
    oos: oos,
    parseItems: parseItems,
    isCheckoutSubmit: isCheckoutSubmit,
    checkoutLinkFrom: checkoutLinkFrom,
    isAccelerated: isAccelerated,
    captureSelection: captureSelection,
    resolveCart: resolveCart,
    buildOffers: buildOffers,
    refreshCartAfterAdd: refreshCartAfterAdd,
    preference: preference,
    vehicleSearchURL: vehicleSearchURL,
    refinementFields: refinementFields,
    vehicleFacetParams: vehicleFacetParams,
    startTrackingAttempt: startTrackingAttempt,
    track: track,
    cartDetailState: cartDetailState,
  };

  if (cfg.live !== true) {
    if (window.console) console.info("[swx-crosssell] disabled (SWX_CROSSSELL.live is not true)");
    return;
  }

  // Full cart: INPUT[type=submit][name=checkout].checkout-button in form action="/cart"
  document.addEventListener(
    "submit",
    function (e) {
      if (bypassOnce) return;
      if (!isCheckoutSubmit(e.target, e.submitter)) return;
      var C = cmx();
      if (!C) {
        log("Convermax not available; native checkout");
        return;
      }
      e.preventDefault();
      intercept(e.target, e.submitter, C);
    },
    true,
  );

  // Mini cart: <a href="/checkout">
  document.addEventListener(
    "click",
    function (e) {
      if (bypassOnce || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
        return;
      var a = checkoutLinkFrom(e.target);
      if (!a) return;
      var C = cmx();
      if (!C) return;
      e.preventDefault();
      intercept(null, null, C, a.href);
    },
    true,
  );

  var css = el(
    "style",
    null,
    ".swx-xs-overlay{--swx-gold:#EEAB10;--swx-checkout:#1B1B1B;--swx-ink:#1F1F1F;--swx-paper:#fff;--swx-divider:#E5E5E5;--swx-muted:#f5f5f5;--swx-subtle:#555;position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.65);display:flex;align-items:center;justify-content:center;padding:16px;font-family:Poppins,sans-serif;font-size:16px;font-weight:400;line-height:1.6}" +
      ".swx-xs-overlay *{box-sizing:border-box}.swx-xs-dialog{background:var(--swx-paper);color:var(--swx-ink);max-width:1100px;width:100%;max-height:92vh;overflow:auto;border-radius:0;font-family:Poppins,sans-serif}" +
      ".swx-xs-body{display:contents}.swx-xs-notes-mobile{display:none}.swx-xs-notes-mobile summary{cursor:pointer;font-weight:600}.swx-xs-notes-mobile summary:focus-visible{outline:2px solid var(--swx-gold);outline-offset:3px}.swx-xs-notes-content{margin-top:8px}" +
      ".swx-xs-head{position:relative;background:var(--swx-paper);color:var(--swx-ink);border-bottom:2px solid var(--swx-gold);padding:24px 48px 24px 24px}.swx-xs-logo{display:block;width:230px;height:71px;max-width:100%;object-fit:contain}" +
      ".swx-xs-head h2{margin:20px 0 8px;text-transform:uppercase;font-family:inherit;font-weight:500;letter-spacing:2.2px;font-size:22px;line-height:1.5;color:var(--swx-ink)}.swx-xs-head p{margin:0;font-size:14px;color:var(--swx-ink)}" +
      ".swx-xs-close{position:absolute;right:12px;top:12px;background:none;border:0;color:var(--swx-ink);font-size:28px;cursor:pointer;padding:4px 10px}.swx-xs-link{background:none;border:0;color:var(--swx-ink);text-decoration:underline;cursor:pointer;padding:0 0 0 6px;font:inherit}" +
      ".swx-xs-list{list-style:none;margin:0;padding:24px;display:grid;gap:24px;grid-template-columns:1fr}.swx-xs-card{border:1px solid var(--swx-divider);padding:24px;border-radius:0;display:flex;flex-direction:column;gap:12px;min-width:0}.swx-xs-card img{display:block;width:100%;height:150px;object-fit:contain}" +
      ".swx-xs-card h3{margin:0;font-family:inherit;font-size:16px;font-weight:400;letter-spacing:0;text-transform:none;line-height:1.6;color:var(--swx-ink)}.swx-xs-card p{margin:0;font-size:13px;color:var(--swx-subtle);line-height:1.6}.swx-xs-price{color:var(--swx-ink);font-size:18px;font-weight:500}" +
      ".swx-xs-notes{background:var(--swx-muted);border:1px solid var(--swx-divider);padding:12px;font-size:13px;white-space:pre-line;max-height:180px;overflow:auto;line-height:1.6}" +
      ".swx-xs-card button,.swx-xs-review{background:var(--swx-gold);color:var(--swx-paper);border:0;padding:12px 16px;cursor:pointer;border-radius:0;text-align:center;text-decoration:none;font:500 12px Poppins,sans-serif;margin-top:auto}.swx-xs-review{background:var(--swx-paper);color:var(--swx-ink);border:1px solid var(--swx-ink)}" +
      ".swx-xs-go{background:var(--swx-checkout);color:var(--swx-paper);border:0;padding:16px 20px;font:500 12px Poppins,sans-serif;letter-spacing:2.4px;text-transform:uppercase;border-radius:0;cursor:pointer}.swx-xs-go:hover,.swx-xs-go:focus-visible{background:var(--swx-gold)}.swx-xs-overlay :is(button,a):focus-visible{outline:2px solid var(--swx-gold);outline-offset:3px}" +
      ".swx-xs-fine{margin:0;padding:0 24px 20px;font-size:12px;color:var(--swx-subtle)}.swx-xs-foot{position:sticky;bottom:0;background:var(--swx-paper);border-top:1px solid var(--swx-divider);padding:16px 24px;display:flex;gap:16px;justify-content:flex-end;flex-wrap:wrap}.swx-xs-skip{background:none;border:0;text-decoration:underline;cursor:pointer;color:var(--swx-subtle);font:400 13px Poppins,sans-serif}" +
      "@media(min-width:1024px){.swx-xs-list{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:639px){.swx-xs-dialog{display:flex;flex-direction:column;overflow:hidden}.swx-xs-head,.swx-xs-foot{flex-shrink:0}.swx-xs-body{display:block;min-height:0;overflow-y:auto;flex:1}.swx-xs-notes-desktop{display:none}.swx-xs-notes-mobile{display:block;white-space:normal}.swx-xs-notes-mobile,.swx-xs-notes-mobile div,.swx-xs-notes-mobile p{height:auto;max-height:none;overflow:visible}.swx-xs-notes-mobile p{white-space:pre-line}.swx-xs-overlay{padding:0;align-items:flex-end}.swx-xs-head{padding:16px 48px 16px 16px}.swx-xs-head h2{font-size:18px;letter-spacing:1px}.swx-xs-list{padding:16px}.swx-xs-foot{flex-direction:column-reverse;padding:16px}.swx-xs-foot .swx-xs-go{width:100%}}",
  );
  document.head.appendChild(css);
})();



